// extracted by mini-css-extract-plugin
var _1 = "ArrowLink__SeeMore___ligQJ";
var _2 = "ArrowLink__wiggle___xUHSv";
export { _1 as "SeeMore", _2 as "wiggle" }
